import { DOCUMENT } from '@angular/common'
import { Component, Input, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core'
import { YouTubePlayer } from '@angular/youtube-player'
import Player from '@vimeo/player'

@Component({
  selector: 'dmmp-video-player',
  templateUrl: './video-player.component.html'
})
export class VideoPlayerComponent implements AfterViewInit {

  @Input() type
  @Input() src
  @ViewChild('vimeoPlayer') playerContainer: ElementRef
  @ViewChild('youTubePlayer') youtubePlayer: YouTubePlayer
  player

  constructor(@Inject(DOCUMENT) public _document) {
  }

  ngAfterViewInit() {
    switch (this.type) {
      case 'youtube': {
        const tag = this._document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'
        this._document.body.appendChild(tag)
        break
      }
      case 'vimeo': {
        this.player = new Player(this.playerContainer.nativeElement)
        break
      }
    }
  }

  stopVideo() {
    switch (this.type) {
      case 'youtube': {
        this.youtubePlayer?.stopVideo()
        break
      }
      case 'vimeo': {
        this.player?.pause()
        break
      }
    }
  }

}
